<script lang="ts">
  import { createEventDispatcher, getContext } from 'svelte';
  const {
    catFamilyFacetFilters,
    catSubFamilyFacetFilters,
    catBrandFacetFilters,
    catBrandFilter,
    catDiscountActiveFilters,
    categoryActiveFilters,
    catselectedPriceFilter,
    catsubFamilyFilter,
  } = getContext<any>('stores');

  import { getAppConfig } from '../../../../common/config/app-config';
  import Text from '../../../common/components/Text.svelte';
  const dispatcher = createEventDispatcher();
  const { currency } = getAppConfig();

  function removeActiveFilter(filter, e) {
    if (filter.includes(':')) {
      $catFamilyFacetFilters = $catFamilyFacetFilters.filter(item => item !== filter);
      $catSubFamilyFacetFilters = $catSubFamilyFacetFilters.filter(item => item !== filter);
      $catBrandFacetFilters = $catBrandFacetFilters.filter(item => item !== filter);
      dispatcher('activeFilterRemoved', {
        filterToBeRemoved: filter,
        subCategory: e.target.dataset.subcat,
      });
    } else {
      $categoryActiveFilters = $categoryActiveFilters.filter(item => item !== filter);
      $catDiscountActiveFilters = $catDiscountActiveFilters.filter(item => item !== filter);
      dispatcher('activeFilterRemoved', {
        filterToBeRemoved: filter,
        subCategory: e.target.dataset.subcat,
      });
    }
  }

  function removeAllFilter() {
    $catsubFamilyFilter = [];
    $catselectedPriceFilter = [];
    $catBrandFilter = [];
    $catDiscountActiveFilters = [];
    $categoryActiveFilters = [];

    dispatcher('allFilterRemoved');
  }
  function getActiveFilterLabel(activeFilter) {
    return activeFilter.includes(':') ? activeFilter.split(':')[1] : activeFilter;
  }
  function getSubCatLabel(activeFilter) {
    console.log('getSubCatLabel', activeFilter);
    let subCategoryLabel = '';
    if (activeFilter.includes(currency)) {
      subCategoryLabel = 'price';
    } else if (activeFilter.includes('%')) {
      subCategoryLabel = 'discount';
    } else if (activeFilter.includes(':')) {
      subCategoryLabel = activeFilter.split(':')[0];
    }
    return subCategoryLabel;
  }

  $: allActiveFilters = [
    ...$catFamilyFacetFilters,
    ...$catSubFamilyFacetFilters,
    ...$categoryActiveFilters,
    ...$catDiscountActiveFilters,
    ...$catBrandFacetFilters,
  ];
</script>

{#if allActiveFilters.length > 0}
  <div class="filter-list border-top">
    {#each allActiveFilters as active}
      <span class="badge rounded-pill border border-grey">
        {@html getActiveFilterLabel(active)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span
          on:click={e => removeActiveFilter(active, e)}
          data-subCat={getSubCatLabel(active)}
          class="c_icon_new c_icon_new--close close"
          aria-label="close"
        ></span>
      </span>
    {/each}
    <button on:click={() => removeAllFilter()} class="btn text-primary">
      <Text key="plp.clearAll" />
    </button>
  </div>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .filter-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    background-color: $primary-white;
    padding: 20px 0 36px 0;

    .badge {
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 16px;
      display: flex;
      align-items: center;
      padding: 12px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      border: 1px solid $secondary-gray-02;
      color: $neutral-dark-02;

      .c_icon_new--close {
        font-size: 16px;
        color: $tertiary-blue-02;
      }
    }

    button {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }
  }
</style>
